import { initTier2NotCheckout } from '@/pages/_shared/not-checkout/tier2'
import { initPageTier } from '@/pages/_shared/tier-utils'
import { registerHandlerElementDetailsModalScript } from '@/utils/queues/handlers/element/details-modal-script'
import { registerHandlerElementLeadGen } from '@/utils/queues/handlers/element/lead-gen'
import { registerHandlerElementGenericSampleKitRequest } from '@/utils/queues/handlers/element/generic-sample-kit-request'
import { registerHandlerElementYoutubeVideo } from '@/utils/queues/handlers/element/youtube-video'
import { registerCarouselComponent } from '@/components/register-component-queue'

export const initTier2 = async (): Promise<void> => {
  await initPageTier(2, [
    initTier2NotCheckout,
    async (): Promise<void> => {
      registerHandlerElementDetailsModalScript()
      registerHandlerElementLeadGen()
      registerHandlerElementGenericSampleKitRequest()
      registerHandlerElementYoutubeVideo()
      registerCarouselComponent()
    }
  ])
  // `webpackPrefetch` prefetches the next tier at `Lowest` network priority when the current tier is loaded,
  // even before the following `import()` is executed.
  import(
    /* webpackChunkName: '@/home/tier3', webpackPrefetch: true */ './tier3'
  ).then(({ initTier3 }) => initTier3())
}
